import { createApiV2 } from "./common";

export const getOrderDetails = (orderNumber) => (token) =>
  createApiV2("GET", `order_number/${orderNumber}/`)(token);

export const getProductsInAnOrder =
  ({ customerUid, orderUid }) =>
  (token) =>
    createApiV2("GET", `customers/${customerUid}/orders/${orderUid}/additional_products/`)(token);

export const getDrawingInAnsOrder =
  ({ customerUid, orderUid }) =>
  (token) =>
    createApiV2("GET", `customers/${customerUid}/orders/${orderUid}/drawings/`)(token);

export const postSplitOrder =
  ({ customerUid, orderUid, payload }) =>
  (token) =>
    createApiV2("POST", `customers/${customerUid}/orders/${orderUid}/split/`)(token, payload);

export default {};
